import { render, staticRenderFns } from "./EducationalGroupTable.vue?vue&type=template&id=27c7d266&"
import script from "./EducationalGroupTable.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports